
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/return-and-cancellation-policy",
      function () {
        return require("private-next-pages/return-and-cancellation-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/return-and-cancellation-policy"])
      });
    }
  